import React, { useState } from "react";
import { staffAPI } from "../../services/api";
import { handleApiError } from "../../utils/errorUtils";
import "../StaffCheckIn.css";

const CheckInAndStartButton = ({
  bookingId,
  appointmentDate,
  refreshBookings,
}) => {
  const [isStarting, setIsStarting] = useState(false);
  const now = new Date();
  const appt = new Date(appointmentDate);
  const allowedCheckInTime = new Date(appt.getTime() - 15 * 60000);

  if (now < allowedCheckInTime) {
    return null;
  }

  const handleCheckInAndStart = async () => {
    try {
      setIsStarting(true);
      await staffAPI.checkInAndStartBooking(bookingId);

      if (refreshBookings) {
        await refreshBookings();
      }
    } catch (err) {
      handleApiError(
        err,
        "CheckInAndStartButton.handleCheckInAndStart",
        (message) => alert(message),
        "Error checking in and starting session"
      );
    } finally {
      setIsStarting(false);
    }
  };

  return (
    <button
      className="action-btn action-btn-success"
      onClick={handleCheckInAndStart}
      disabled={isStarting}
    >
      {isStarting ? "Starting..." : "Check In & Start"}
    </button>
  );
};

export default CheckInAndStartButton;
